import React from 'react'

type TvProps = {
  className?: string
}

const _Tv = (props: TvProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7C2.44772 7 2 7.44772 2 8V19C2 19.5523 2.44772 20 3 20H19C19.5523 20 20 19.5523 20 19V8C20 7.44772 19.5523 7 19 7H3ZM0 8C0 6.34315 1.34315 5 3 5H19C20.6569 5 22 6.34315 22 8V19C22 20.6569 20.6569 22 19 22H3C1.34315 22 0 20.6569 0 19V8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29289 0.292893C5.68342 -0.0976311 6.31658 -0.0976311 6.70711 0.292893L11 4.58579L15.2929 0.292893C15.6834 -0.0976311 16.3166 -0.0976311 16.7071 0.292893C17.0976 0.683417 17.0976 1.31658 16.7071 1.70711L11.7071 6.70711C11.3166 7.09763 10.6834 7.09763 10.2929 6.70711L5.29289 1.70711C4.90237 1.31658 4.90237 0.683417 5.29289 0.292893Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_Tv)
